import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 2 · NIVEAU 2 — LA PLONGÉE.

     0:00  bloc E1       28 s   la plongée — l'immobilité devient coûteuse
     0:28  respiration    4 s
     0:32  bloc E2       22 s   crête : les trois natures ensemble
     0:54  respiration    4 s

   Deuxième niveau du monde 2, sans boss. Il pousse la thèse du monde à son pic
   (E2 réunit les trois natures) avant de rendre la main au niveau final.

   ⚠️ Blocs 5 → 8 de l'ancien `monde-2`, re-basés (offset 70 s).
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-2-2',
  duration: 58,
  blocks: [
    // Le champ se densifie : on introduit le NOYAU, le rocher dense qui tient
    // assez longtemps pour rester un vrai choix même sous un build avancé.
    // Toujours à l'écart de la colonne centrale.
    {
      at: 0,
      wave: 'e1-plongee',
      obstacles: [
        { at: 3, obstacle: 'astero-eclat', x: -185 },
        { at: 7, obstacle: 'astero-noyau', x: 215 },
        { at: 12, obstacle: 'astero-eclat', x: -230 },
      ],
    },
    { at: 28, wave: 'respiration' },
    { at: 32, wave: 'e2-crete' },
    { at: 54, wave: 'respiration' },
  ],
});
